// Set up your root reducer here...
import {combineReducers} from 'redux';
import surfaces from './surfaceReducers';
import categories from './categoryReducers';
import options from './optionReducers';
import matches from './matchReducers';
import products from './productReducers';
import choices from './choiceReducers';

export default combineReducers({
    surfaces,
    categories,
    options,
    matches,
    products,
    choices,
});


// WEBPACK FOOTER //
// ./src/reducers/index.js